import {
  computed,
  toRef,
} from "vue";

import {
  isEmpty,
} from "lodash-es";

export default function ModelAPI(props) {
  const model = toRef(props, "model");

  const hasModelParam = computed(() => {
    return model.value?.param && !isEmpty(model.value.param);
  });

  const hasModelQuery = computed(() => {
    return model.value?.query && !isEmpty(model.value.query);
  });

  return {
    hasModelParam,
    hasModelQuery,
  };
}
